import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cmt-account-orders-skeleton',
  templateUrl: './account-orders-skeleton.component.html',
  styleUrl: './account-orders-skeleton.component.scss',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountOrdersSkeletonComponent {}
